import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import classes from './Error.module.scss';

const ErrorVariant = {
    Default: 'default',
    Info: 'info',
    Success: 'success',
    FormAddPet: 'formAddPet'
} as const;

interface ErrorProps {
    title: string | React.ReactNode;
    icon?: IconProp;
    variant?: (typeof ErrorVariant)[keyof typeof ErrorVariant];
    className?: string;
}

export const Error: React.FC<ErrorProps> = ({
    title,
    icon,
    variant = ErrorVariant.Default,
    className
}) => {
    if (variant === ErrorVariant.Info) {
        icon = faInfoCircle;
    }

    return (
        <div className={clsx(classes.root, className, classes[variant])}>
            {icon && <FontAwesomeIcon icon={icon} className={classes.icon} />}

            {title}
        </div>
    );
};
